import { useQueryClient } from "@tanstack/react-query";

import { topicsPrefetchQueryData } from "./useTopics";

const genPrefetchData = (link: string) => {
  switch (link) {
    case "/mypage/topic-settings":
      return topicsPrefetchQueryData();
    default:
      return;
  }
};

export const useMypagePrefetch = (link: string) => {
  const queryClient = useQueryClient();
  const data = genPrefetchData(link);

  if (!data) return () => {};

  return () => {
    queryClient.prefetchQuery(
      data.queryKey,
      async () => await data.fetchFunc()
    );
  };
};